import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue';
import Unity1weekTop from '../views/Unity1weekTopView.vue';
import Unity1weekDetail from '../views/Unity1weekDetail.vue';
import PrivacyPolicy from '../views/PrivacyPolicyView.vue';
import AppListView from '../views/AppListView.vue';
// import Home from './components/Home.vue'AppListView
// import Test from './components/Test.vue'

const routes = [
    { path: '/', component: HomeView },
    { path: '/unity1week', component: Unity1weekTop },
    { path: '/unity1week/detail', component: Unity1weekDetail },
    { path: '/privacy-policy', component: PrivacyPolicy },
    { path: '/app-list', component: AppListView },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router